import  { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Card,
    Chip,
    Grid,
    // LinearProgress,
    Typography,
    Button,
    Skeleton,
} from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CategoryIcon from '@mui/icons-material/Category';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

import { fetchParticipantActiveExercise } from '../../../RTK/features/participantProfile/participantProfileSlice';
import { useDispatch, useSelector } from 'react-redux';

const difficultyStyle = {
    easy: { bg: '#f0fdf4', color: '#15803d' },
    intermediate: { bg: '#fefce8', color: '#a16207' },
    hard: { bg: '#fef2f2', color: '#b91c1c' },
    default: { bg: '#f3f4f6', color: '#374151' },
};

const ActiveScenarioCard = ({ scenario, onClick }) => {
    const { name, thumbnail_url, severity, category_name } = scenario;
    // const { name, thumbnail_url, difficulty, duration, squadInfo, category_name, progressPct } = scenario;

    const diffKey = severity?.toLowerCase() ?? 'intermediate';
    const { bg: chipBg, color: chipColor } = difficultyStyle[diffKey] ?? difficultyStyle.default;

    return (
        <Card
            sx={{
                borderRadius: '16px',
                overflow: 'hidden',
                cursor: 'default',
                position: 'relative',
                bgcolor: '#212B36',
                border: '1px solid rgba(0, 184, 217, 0.15)',
                boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.4), 0px 0px 1px rgba(0, 184, 217, 0.2)',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': {
                    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(0, 184, 217, 0.4)',
                    transform: 'translateY(-4px)',
                    borderColor: 'rgba(0, 184, 217, 0.3)'
                },
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Box sx={{ height: 160, width: '100%', overflow: 'hidden', flexShrink: 0, position: 'relative' }}>
                {thumbnail_url ? (
                    <Box
                        component="img"
                        src={thumbnail_url}
                        alt={name}
                        sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                ) : (
                    <Box sx={{ width: '100%', height: '100%', bgcolor: '#161C24' }} />
                )}

                {/* <Chip
                    label={`${Math.round(progressPct)}% done`}
                    size="small"
                    sx={{
                        position: 'absolute',
                        top: 10,
                        right: 10,
                        bgcolor: '#00B8D9',
                        '& .MuiChip-label': {
                            color: '#ffffff'
                        },
                        fontWeight: 700,
                        fontSize: '0.75rem',
                        backdropFilter: 'blur(8px)',
                        boxShadow: '0 2px 8px rgba(0, 184, 217, 0.4)',
                        border: '1px solid rgba(255, 255, 255, 0.2)',
                    }}
                /> */}
            </Box>

            <Box sx={{ p: 2.5, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1.5 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700, color: 'rgba(255,255,255,0.87)' }}>
                        {name}
                    </Typography>
                    <ChevronRightIcon sx={{ color: 'rgba(255,255,255,0.5)', flexShrink: 0 }} />
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5, gap: 1, flexWrap: 'wrap', justifyContent: 'space-between' }}>
                    <Chip
                        icon={<FitnessCenterIcon sx={{ fontSize: 14, color: "#ffffff !important" }} />}
                        label={severity}
                        size="small"
                        sx={{ bgcolor: chipBg, color: chipColor, fontWeight: 500, borderRadius: '999px', fontSize: '0.75rem' }}
                    />

                    {/* {squadInfo && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <GroupIcon sx={{ fontSize: 16, color: 'rgba(255,255,255,0.6)' }} />
                            <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.6)' }}>{squadInfo}</Typography>
                        </Box>
                    )}

                    {duration && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <AccessTimeIcon sx={{ fontSize: 16, color: 'rgba(255,255,255,0.6)' }} />
                            <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.6)' }}>{duration}</Typography>
                        </Box>
                    )} */}
                </Box>

                <Box sx={{ borderTop: '1px dashed rgba(255,255,255,0.2)', my: 1 }} />

                {category_name && (
                    <Box
                        sx={{
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            gap: 0.5, py: 1, px: 2.5, mt: 1,
                            bgcolor: 'rgba(255,255,255,0.08)', borderRadius: '36px', width: '100%',
                        }}
                    >
                        <CategoryIcon sx={{ fontSize: 18, color: 'rgba(255,255,255,0.87)' }} />
                        <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.87)' }}>{category_name}</Typography>
                    </Box>
                )}

                {/* <Box sx={{ flexGrow: 1 }} /> */}

                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<PlayArrowIcon />}
                    fullWidth
                    size="small"
                    onClick={onClick}
                    sx={{ mt: 2, alignSelf: 'end' }}

                >
                    Continue
                </Button>
            </Box>

            {/* <LinearProgress
                variant="determinate"
                value={progressPct}
                sx={{
                    height: 8,
                    borderRadius: 0,
                    bgcolor: '#f3f4f6',
                    '& .MuiLinearProgress-bar': {
                        background: 'linear-gradient(90deg, #61F3F3, #00B8D9)',
                        borderRadius: 4,
                    },
                }}
            /> */}
        </Card>
    );
};

const ActiveScenarios = () => {
    const navigate = useNavigate();

    const handleContinueScenario = (scenarioId) => {
        navigate(`/participant/scenario/${scenarioId}`);
    };
    const dispatch = useDispatch();
    const { activeExercises: scenariosFromRedux, loading, error } = useSelector(state => state.participantProfile);

    useEffect(() => {
        dispatch(fetchParticipantActiveExercise());
    }, [dispatch]);

    return (loading ?
        <Grid container spacing={2}>
            {[1, 2, 3, 4].map((index) => (
                <Grid item xs={12} sm={6} lg={4} xl={3} key={index}>
                    <Skeleton
                        variant="rectangular"
                        width="100%"
                        height={400}
                        sx={{
                            bgcolor: '#2a3f5f',
                            '&::after': {
                                background: 'linear-gradient(90deg, rgba(0, 184, 217, 0.1), rgba(0, 184, 217, 0.3), rgba(0, 184, 217, 0.1))',
                            }
                        }}
                    />
                </Grid>
            ))}
        </Grid>
        :
        <Grid container spacing={2}>
            {scenariosFromRedux?.length > 0 ? scenariosFromRedux.map((scenario) => (
                <Grid item xs={12} sm={6} lg={4} xl={3} key={scenario.id}>
                    <ActiveScenarioCard
                        scenario={scenario}
                        onClick={() => handleContinueScenario(scenario.id)}
                    />
                </Grid>
            )) : (
                <Grid item xs={12}>
                    <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.87)', textAlign: 'center' }}>
                        No active scenarios available.
                    </Typography>
                </Grid>
            )}
        </Grid>
    );
};

export default ActiveScenarios;
